import AppHeader from "components/main/app-header/AppHeader";
import AppNav from "components/main/app-nav/AppNav";
import { useContext } from "react";
import { Outlet } from "react-router-dom";
import { getAppContext } from 'config/AppContext';
import Notification from "components/common/notifications/Notification";
import useLocationManager from "utilities/hooks/useLocationManager";

const AppIndex = () => {
    const locationManager = useLocationManager();
    const context = getAppContext(useContext);
    context.setLocationManagerData(locationManager);
    return (
        <>
            <AppNav />
            <main className='app-body'>
                <Outlet />
            </main>
            <AppHeader />
            <Notification />
        </>
    );
};

export default AppIndex;
